import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';


class User {
    constructor(obj){
        Object.assign(this, obj)
    }

    getFullName() {
        return this.given_name + " " + this.family_name;
    }
}


class UsersAPI extends API {

    url() {
        return config.get("re.url") + "users";
    }

    urlManagement() {
        return config.get("re.management");
    }

    urlDomain() {
        return config.get("re.domain");
    }

    // Readme Doc: https://gitlab.com/singularmentor/ecu/-/wikis/API-Administrativa#listar-todos-los-usuarios-que-un-usuario-autenticado-puede-acceder
    getAll() {

        return new Promise((resolve, reject) => {
            axios.get(
                this.urlManagement() + "clients/ecu/users/account",
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    const users = [];
                    response.data.users.forEach(u => {
                      users.push(new User(u));
                    });
                    resolve(users);
                } else {
                    const err = new Error(response.status, "Failed to fetch users", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    get(encodedUserId) {

        // https://sinexiar.com/smre/management/clients/ecu/users/{String:urlencode(id)}
        return new Promise((resolve, reject) => {
            axios.get(
            //   this.url() +"/"+ id,
              this.urlManagement() + "clients/ecu/users/"+ encodedUserId,
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(new User(response.data));
                } else {
                    const err = new Error(response.status, "Failed to fetch user", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    // Service to obtain token after user login in Auth0
    loginForToken(applicationName, username, password) {
        return new Promise((resolve, reject) => {
            axios.post(
              this.urlDomain()+ applicationName + "/auth/login",
              {
                "username": username,
                "password": password,
              },
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(response.data.token);
                } else {
                    const err = new Error(response.status, "Failed to login in Auth0 to retrieve token", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    getSessionUser() {
        return new Promise((resolve, reject) => {
            axios.get(
              this.urlManagement()+"/clients/ecu/users/auth",
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(new User(response.data));
                } else {
                    const err = new Error(response.status, "Failed to fetch user", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }


    update(user) {
        
        return new Promise((resolve, reject) => {
            debugger
            axios.put(
                this.urlManagement() + "clients/ecu/users/" + encodeURI(user.id),
                user,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to update user", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {

            axios.delete(
                this.urlManagement() + "clients/ecu/users/" + encodeURI(id),
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to delete user", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    create(user) {
        return new Promise((resolve, reject) => {
            axios.post(
                this.urlManagement() + "clients/ecu/users",
                user,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 300) {

                    resolve(new User(response.data.user));
                } 
                else {
                    const err = new Error(response.status, "Something went wrong when trying to create a user", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                if (err.response && err.response.status === 303){
                    const handleError = new Error(err.response.status, "Username already exist", "Username already exist");
                    reject(handleError);
                } else {
                    reject(err);
                }
                    
            });
        });
    }
}

export {
    UsersAPI, User
};